import { render } from "./SpecialForm.vue?vue&type=template&id=eaba2852&ts=true"
import script from "./SpecialForm.vue?vue&type=script&lang=ts"
export * from "./SpecialForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__